import angular from 'angular';
import displayTemplateComponent from './displayTemplate.component';

let displayTemplateModule = angular.module('displayTemplate', [])

.component('displayTemplate', displayTemplateComponent)

.name;

export default displayTemplateModule;



// WEBPACK FOOTER //
// ./client/app/components/displayTemplate/displayTemplate.js